export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

export function strToDateStr(str, fmt) {
  if (typeof str === 'string') {
    let date = new Date(str);
    return formatDate(date, fmt);
  }
  return str;
}

export function getDateByNum(num) {
  var date1 = new Date();
  //今天时间
  var time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate()
  var date2 = new Date(date1);
  date2.setDate(date1.getDate() + num);
  //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
  var time2 = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();
  return time2;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}


export function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);//window.location.search
  console.log(urlParams,'==========urlParams')
  return urlParams.get(param);
}



// WEBPACK FOOTER //
// ./src/utils/date.js